import { useTranslation } from "react-i18next";
import type { IAddModalProps } from "@app/dashboard/types/innerLayout/iframes/add-iframe"; 
import type { IButton } from "libs/design-system/src/types/Button/button";
import type { IModalSharedProps } from "libs/design-system/src/types/modal";
import { Check, Xmark } from "libs/design-system/src/assets/Icons";
import { Modal, StatusIndicator } from "@unified-checkout/design-system";
import { IframeModal } from "..";


export const AddModal = ({
  open,
  isLoading,
  isError,
  isSuccess,
  iframeForm,
  onClose,
  onConfirm,
  onFormChange,
}: IAddModalProps) => {
  const { t } = useTranslation();

  const isProcessDone = isSuccess || isError;

  const title = isProcessDone ?
    ""
    :
    t("innerLayout.iFramesPage.header.add")

  const btns = isProcessDone ?
    []
    :
    [
      {
        size: "md",
        color: "primary",
        variant: "contained",
        text: t(`innerLayout.iFramesPage.deleteModal.confirmButton`),
        onClickHandler: onConfirm,
        loading: isLoading,
        disabled: isLoading,
      } as IButton,
      {
        size: "md",
        color: "secondary",
        variant: "outlined",
        text: t("innerLayout.iFramesPage.deleteModal.cancelButton"),
        onClickHandler: onClose,
      } as IButton,
    ];

  const modalProps: IModalSharedProps = {
    state: "default",
    open,
    position: "center",
    onCloseHandler: onClose,
    closeOnClickOutside: true,
    hasCloseIcon: isProcessDone,
    title: title,
    btnsProps: btns
  }

  const status = isProcessDone ?
    (
      <StatusIndicator
        status={isError ? "error" : "success"}
        icon={isError ? Xmark : Check}
        hintText={
          isError
            ? t("innerLayout.errors.smthWentWrong")
            : t("innerLayout.iFramesPage.addModal.successMessage")
        }
      />
    )
    :
    <IframeModal form={iframeForm} setForm={onFormChange} />;

  return (
    <Modal {...modalProps}>
      {status}
    </Modal>
  );
};
